export default __webpack_public_path__ + "static/media/DE.cfbb0cf0.svg";